import PropTypes from 'prop-types';
import React from 'react';

import ProjectCard from 'components/Cards/ProjectCard/ProjectCard';

import styles from './PortfolioProjectsDisplay.module.scss';

const portfolioProjectRowShape = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  project: PropTypes.object,
  roles: PropTypes.array,
};

/**
 * {@link ProjectCard} grid — two cards per row (one column on small screens).
 */
const PortfolioProjectsDisplay = ({
  title,
  items,
  user,
  loading,
  className,
}) => {
  if (loading && (!items || items.length === 0)) {
    return (
      <p className={`${styles.loading} ${className || ''}`.trim()}>
        Loading portfolio projects…
      </p>
    );
  }

  if (!items || items.length === 0) {
    return null;
  }

  return (
    <section className={`${styles.section} ${className || ''}`.trim()}>
      <h2 className={styles.title}>{title}</h2>
      <div className={styles.grid}>
        {items.map((credit, idx) => (
          <div
            key={credit.id != null ? String(credit.id) : `credit-${idx}`}
            className={styles.cell}
          >
            <ProjectCard
              isOwn={false}
              project={credit.project}
              roles={credit.roles || []}
              userViewingPage={user}
              user={user}
              aspectRatio="16:9"
              roundedCorners
              compactTextPreview
            />
          </div>
        ))}
      </div>
    </section>
  );
};

PortfolioProjectsDisplay.propTypes = {
  title: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape(portfolioProjectRowShape)),
  user: PropTypes.object.isRequired,
  loading: PropTypes.bool,
  className: PropTypes.string,
};

PortfolioProjectsDisplay.defaultProps = {
  title: 'Portfolio projects',
  items: [],
  loading: false,
  className: '',
};

export default PortfolioProjectsDisplay;
